import {needAuth, noAuh} from "../instance/Instance";
import {login} from "../../redux/slice/authSlice";
import axios from "axios";
import {decodeToken, getToken} from "../../components/commonmethod/CommonMethod";
const BASE_URL = import.meta.env.VITE_BASE_URL;

async function useLogin(loginUser) {
    localStorage.removeItem('accessToken');
    try {
        const response = await noAuh.post('/user/login', loginUser);
        if (response.status === 200) {
            const accessToken = response.data.accessToken;
            const refreshToken = response.data.refreshToken;

            const user = JSON.parse(decodeToken(accessToken));

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            return user;
        }else {
            // 200이 아닌 경우
            alert("서버와 연결할 수 없습니다. 잠시 후 다시 시도하세요.");
            throw new Error("서버 연결 실패");
        }
    }catch (error){
        console.error(error);
        if(error.response.status === 400) {
            alert("아이디와 비밀번호를 확인하세요");
            throw new Error("아이디와 비밀번호가 잘못되었습니다.");
        }
        else if(error.response.status === 401) {
            alert("아이디의 사용기한이 만료되었습니다. 관리자에게 문의하세요.");
            throw new Error("아이디 사용기한 만료");
        }else if(error.response.status === 423) {
            alert("비활성화된 아이디 입니다. 관리자에게 문의하세요.");
            throw new Error("비활성화된 아이디 입니다.");
        }
        else {
            // 서버 응답이 없을 경우
            alert("서버와 연결할 수 없습니다. 잠시 후 다시 시도하세요.");
            throw new Error("서버 연결 실패");
        }
    }

}

async function tokenValidation() {
    const token = getToken();
    if(token) {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json', // Adjust the content type if needed
        };
        try{
            const response =  await needAuth.post('/user/tokenValidation', null, { headers });
        }catch (error){
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        localStorage.removeItem('menus');
        return error;
        }
    }
}




async function userLogout() {
    const refreshToken = localStorage.getItem('refreshToken');
    // localStorage.removeItem('accessToken');
    // localStorage.removeItem('refreshToken');
    // localStorage.removeItem('user');
    // localStorage.removeItem('menus');
    // localStorage.removeItem('topMenuId');
    localStorage.clear();

    const tokenRefreshConfig = {
        headers: {
            'Authorization': `Bearer ${refreshToken}`
        }
    };
    try{
        const response = await axios.get(BASE_URL + `/user/logout`, tokenRefreshConfig);
        console.log("logout")
    }catch (error){
    }
}

async function tempLogin() {
    localStorage.removeItem('accessToken');
    const response ={};
    response.status =200;
    response.user ={username:"temp"}
    return response;
}


export {useLogin,tokenValidation, userLogout, tempLogin};